import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import { PartnerClientsTableItem } from 'types/partnerClientsTable';
import { PartnerTrialClientsTableRow } from 'containers/PartnerClientsTable/PartnerTrialClientsTableRow';
import { HoverableTooltipComponent } from 'design/hoverableTooltip/hoverableTooltipComponents';
import { UnderlinedTextComponent } from 'design/underlinedText/underlinedTextComponents';

type Props = {
  items: PartnerClientsTableItem[];
  activeItemId?: number;
  onItemClick(item: PartnerClientsTableItem): void;
};

export const PartnerTrialClientsTable = (props: Props) => {
  const { items, activeItemId, onItemClick } = props;

  const {
    partnerClientsTable: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  // Мемоизированные строки таблицы клиентов.
  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <PartnerTrialClientsTableRow
        key={item.id}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh size="m" text={ownDictionary.organizationLabel} />
          <TableTh size="auto" text={ownDictionary.contactFullNameLabel} />
          <TableTh size="m" text={ownDictionary.positionLabel} />
          <TableTh size="l" text={ownDictionary.phoneLabel} />
          <TableTh size="s" text={ownDictionary.orgSizeLabel} />
          <TableTh
            size="m"
            text={
              <HoverableTooltipComponent
                text={sharedDictionary.licensesTooltipText}
              >
                <UnderlinedTextComponent>
                  {ownDictionary.licensesCountLabel}
                </UnderlinedTextComponent>
              </HoverableTooltipComponent>
            }
          />
          <TableTh size="m" text={ownDictionary.expectedIncomeLabel} />
          <TableTh size="l" text={ownDictionary.subscribtionStatusLabel} />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
